import { wealthProApi } from "../../redux/api";

const graphMailFolderEndpoints = wealthProApi.enhanceEndpoints({
    addTagTypes: ['graphMailFolders']
}).injectEndpoints({
    endpoints: ((builder) => ({
        fetchMailFoldersList: builder.query({
            query: ({ userId }: { userId: string | null }) => ({
                url: userId ? `api/graph/graph/${userId}/mail-folders` : `api/graph/me/mail-folders`,
            })
        })
    }))
});

export const {
    useFetchMailFoldersListQuery,
    useLazyFetchMailFoldersListQuery
} = graphMailFolderEndpoints;